import { ProjectUser } from '@monorepo/shared/apiClient/types';
import { ProjectPermissionRoles } from 'mapistry-shared';

export const NO_PERMISSION_TOOLTIP =
  'You do not have permission to perform this action.';

// Display / lookup order, most to least powerful
export const projectRolesRankedByPower = [
  ProjectPermissionRoles.PROJECT_PRIMARY_ADMIN,
  ProjectPermissionRoles.PROJECT_ADMIN,
  ProjectPermissionRoles.PROJECT_CONTRIBUTOR,
  ProjectPermissionRoles.PROJECT_VIEWER,
  ProjectPermissionRoles.SITE_MAINTENANCE,
];

export function isSiteAdmin(user: ProjectUser): boolean {
  return user.projectRoles === ProjectPermissionRoles.PROJECT_ADMIN;
}

export function isPrimarySiteAdmin(user: ProjectUser): boolean {
  return user.projectRoles === ProjectPermissionRoles.PROJECT_PRIMARY_ADMIN;
}

export function isOrgAdmin(user: ProjectUser): boolean {
  return user.isOrganizationAdmin === true;
}
